<template>
	<div>
		好友个人主页
	</div>
</template>

<script>
	export default{
		name:"friend-page"
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Chats/FriendPage.vue